export default __webpack_public_path__ + "static/media/head-logo.dedc8f28.jpeg";